exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-add-new {\n  float: right;\n  display: inline-block;\n  height: 29px;\n  line-height: 9px;\n  margin-left: 10px;\n}\n\n.label-class {\n  font-weight: 600;\n  padding: 5px 10px;\n  display: inline-block;\n  background-color: #fff;\n  border-radius: 4px;\n}\n\n.selected {\n  font-weight: 600;\n  padding: 5px;\n  display: inline-block;\n  background-color: #00a65a;\n  margin-right: 5px;\n  border-radius: 100%;\n}\n\n.bg-primary {\n  background-color: #3c8dbc;\n  border-color: #367fa9;\n}\n\n.nav.nav-stacked.classes li {\n  margin-top: 0;\n  display: inline-block;\n  float: left;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/pages/provider-characteristic/provider-characteristic.component.css
// module id = ../../../../../src/app/main/pages/provider-characteristic/provider-characteristic.component.css
// module chunks = main